// BOARD
export const COLS = 10; //width
export const ROWS = 20; // height

// PIECE
export const BLOCK_SIZE = 20;
export const TETRIMINOS = {};